(() => {
  'use strict';

  const FALLBACK_MESSAGE = {
    enabled: true,
    id: 'messaggio-1',
    eyebrow: 'Nuovo messaggio',
    title: 'Un messaggio per te',
    text: 'Benvenuta nella nuova area messaggi di RA Boutique. Qui troverai promozioni, novità e comunicazioni importanti.',
    buttonLabel: 'Scopri le novità',
    buttonUrl: '/collections/all'
  };

  let overlay;
  let lastTrigger;
  let currentMessage = FALLBACK_MESSAGE;

  const readConfig = () => {
    const node = document.querySelector('[data-ra-message-config]');
    if (!node) return { ...FALLBACK_MESSAGE };

    try {
      const config = JSON.parse(node.textContent || '{}');
      return {
        ...FALLBACK_MESSAGE,
        ...config,
        id: config.id || FALLBACK_MESSAGE.id,
        buttonUrl: config.buttonUrl || FALLBACK_MESSAGE.buttonUrl
      };
    } catch (error) {
      return { ...FALLBACK_MESSAGE };
    }
  };

  const storageKey = () => `ra_message_read_${currentMessage.id}`;

  const isRead = () => {
    try {
      return window.localStorage.getItem(storageKey()) === '1';
    } catch (error) {
      return false;
    }
  };

  const markRead = () => {
    try {
      window.localStorage.setItem(storageKey(), '1');
    } catch (error) {
      // Local storage can be unavailable in private browsing.
    }

    document.querySelectorAll('.ra-message-badge').forEach((badge) => {
      badge.hidden = true;
    });
  };

  const iconMarkup = `
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <rect x="3" y="5" width="18" height="14" rx="2"></rect>
      <path d="m4 7 8 6 8-6"></path>
    </svg>
    <span class="ra-message-badge" aria-label="1 nuovo messaggio">1</span>
  `;

  const createTrigger = () => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ra-message-trigger';
    button.setAttribute('aria-label', 'Apri i messaggi');
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = iconMarkup;

    const badge = button.querySelector('.ra-message-badge');
    badge.hidden = isRead();
    button.addEventListener('click', () => openDrawer(button));
    return button;
  };

  const drawerMarkup = () => {
    const button = currentMessage.buttonLabel && currentMessage.buttonUrl
      ? `<a class="ra-message-card__button" href="${currentMessage.buttonUrl}">${currentMessage.buttonLabel}</a>`
      : '';

    return `
      <section class="ra-message-drawer" role="dialog" aria-modal="true" aria-labelledby="ra-message-heading">
        <header class="ra-message-drawer__header">
          <h2 class="ra-message-drawer__heading" id="ra-message-heading">Messaggi</h2>
          <button class="ra-message-drawer__close" type="button" aria-label="Chiudi i messaggi">&times;</button>
        </header>
        <div class="ra-message-drawer__content">
          <article class="ra-message-card">
            <span class="ra-message-card__eyebrow">${currentMessage.eyebrow || ''}</span>
            <h3 class="ra-message-card__title">${currentMessage.title || ''}</h3>
            <p class="ra-message-card__text">${currentMessage.text || ''}</p>
            ${button}
          </article>
        </div>
      </section>
    `;
  };

  const bindDrawer = () => {
    overlay.querySelector('.ra-message-drawer__close')?.addEventListener('click', closeDrawer);
  };

  const createDrawer = () => {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'ra-message-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      document.body.appendChild(overlay);
      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) closeDrawer();
      });
    }

    overlay.innerHTML = drawerMarkup();
    bindDrawer();
  };

  const openDrawer = (trigger) => {
    currentMessage = readConfig();
    createDrawer();
    lastTrigger = trigger;
    markRead();
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ra-message-lock');

    document.querySelectorAll('.ra-message-trigger').forEach((item) => {
      item.setAttribute('aria-expanded', 'true');
    });

    window.setTimeout(() => {
      overlay.querySelector('.ra-message-drawer__close')?.focus();
    }, 20);
  };

  const closeDrawer = () => {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ra-message-lock');

    document.querySelectorAll('.ra-message-trigger').forEach((item) => {
      item.setAttribute('aria-expanded', 'false');
    });

    lastTrigger?.focus();
  };

  const removeTriggers = () => {
    document.querySelectorAll('.ra-message-trigger').forEach((trigger) => trigger.remove());
    document.querySelectorAll('[data-ra-message-processed]').forEach((item) => {
      delete item.dataset.raMessageProcessed;
    });
  };

  const injectMobile = () => {
    document.querySelectorAll('.m-header__mobile-right .mobile-wishlist').forEach((wishlist) => {
      if (wishlist.nextElementSibling?.classList.contains('ra-message-trigger')) return;
      wishlist.insertAdjacentElement('afterend', createTrigger());
    });
  };

  const injectDesktop = () => {
    const selectors = [
      '.m-header__desktop .m-header__wishlist',
      '.m-header__desktop .wishlist-page-widget',
      '.m-header__desktop .h-wishlist-icon'
    ];

    document.querySelectorAll(selectors.join(',')).forEach((wishlist) => {
      if (wishlist.closest('.mobile-wishlist')) return;
      if (wishlist.dataset.raMessageProcessed === 'true') return;
      wishlist.dataset.raMessageProcessed = 'true';
      wishlist.insertAdjacentElement('afterend', createTrigger());
    });
  };

  const refresh = () => {
    const nextMessage = readConfig();
    const changed = nextMessage.id !== currentMessage.id || nextMessage.enabled !== currentMessage.enabled;
    currentMessage = nextMessage;

    if (!currentMessage.enabled) {
      removeTriggers();
      closeDrawer();
      return;
    }

    if (changed) {
      document.querySelectorAll('.ra-message-badge').forEach((badge) => {
        badge.hidden = isRead();
      });
    }

    injectMobile();
    injectDesktop();
  };

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && overlay?.classList.contains('is-open')) closeDrawer();
  });

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(refresh, 0);
  });

  document.addEventListener('shopify:section:select', () => {
    window.setTimeout(refresh, 0);
  });

  const start = () => {
    currentMessage = readConfig();
    createDrawer();
    refresh();

    const observer = new MutationObserver(() => refresh());
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
